import React from 'react';
import {connect} from 'react-redux';

import * as DisplayMode from 'constants/DisplayMode';
import * as FavouriteState from 'constants/FavouriteState';

import MatchHeader from './MatchHeader.jsx';
import MatchStats from './matchStats/MatchStats.jsx';
import Group from './Group.jsx';

import {groupsSortFunc} from 'rendering-commons/Sorting';

import groupNesting from 'shared/glossary/group-nesting.json';

class RegularMatch extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        match: React.PropTypes.object,
        groups: React.PropTypes.object,
        isChoosenMatch: React.PropTypes.bool,
        displayMode: React.PropTypes.object.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        gridSelection: React.PropTypes.object.isRequired,
        selectionToggleMatchAction: React.PropTypes.func.isRequired
    };

    static renderParentGroup(group, nestingLevel, props) {
        const groupId = group.get('id');
        const hasChildGroups = group.get('childGroups') ? group.get('childGroups').size > 0 : false;

        let groupElements = [];
        const childGroups = group.get('childGroups');

        groupElements.push((<Group key={groupId} id={groupId} hasChildGroups={hasChildGroups} {...props} />));

        if (childGroups) {
            nestingLevel += 1;
            const childProps = {
                ...props,
                nestingLevel,
                isParentExpanded: group.get('isExpanded'),
                hasParent: true
            };

            childGroups.forEach((childGroup) => {
                const childGroupElements = RegularMatch.renderParentGroup(childGroup, nestingLevel, childProps);
                groupElements = groupElements.concat(childGroupElements);
            });
        }

        return groupElements;
    }

    constructor(props) {
        super(props);
    }

    render() {
        const {
            section,
            match,
            groups,
            displayMode,
            gridLocalization,
            isChoosenMatch,
            gridSelection,
            selectionToggleMatchAction
            } = this.props;

        if (match === undefined) {
            return false;
        }

        const matchId = match.get('id');

        const sortedMatchGroups = groups.sort(groupsSortFunc);

        let headerCls = 'event';

        const isFullyLoaded = match.get('isFullyLoaded');

        const isLive = section === "live";

        let isClosed = false;
        if (match.get('isClosed') === true || (!isLive && !isFullyLoaded)) {
            headerCls += ' closed';
            isClosed = true;
        }

        let showMatch = true;

        if (isLive) {
            if (displayMode.type === DisplayMode.FAVOURITE) {
                const favouriteState = match.get('favouriteState');
                if (favouriteState === FavouriteState.NONE) {
                    headerCls += ' hidden';
                    showMatch = false;
                }
            } else if (displayMode.type === DisplayMode.MATCH) {
                if (matchId !== displayMode.id) {
                    headerCls += ' hidden';
                    showMatch = false;
                }
            }
        }

        if (!showMatch) {
            return false;
        }

        let builtMatchGroups = buildGroups(sortedMatchGroups);
        builtMatchGroups = buildCustomNestingGroups(match.get('realSportId'), builtMatchGroups);
        const hasGroups = builtMatchGroups.length > 0;

        const props = {
            section,
            matchId,
            gridLocalization,
            isChoosenMatch
        };

        const headerProps = {
            ...props,
            gridSelection,
            selectionToggleMatchAction,
            isChoosenMatch
        };

        return (
            <div className={headerCls}>
                <MatchHeader id={matchId} {...headerProps} />
                {!isClosed && hasGroups && <div className="event-body">
                    {builtMatchGroups.map((g) => RegularMatch.renderParentGroup(g, 1, props))}
                </div>}
                {!isClosed && isLive && <MatchStats key={matchId} {...props}/>}
            </div>
        );
    }
}

function select(state, props) {
    const {section, id, gridLocalization, matchId} = props;
    const match = state.application.getIn([section, 'matches', id]);
    const groups = state.application.getIn([section, 'groups']).filter(g => g.get('matchId') === id && g.get('type') !== 0);
    const displayMode = state.application.get('displayMode');

    const isChoosenMatch = (id == matchId);

    return {
        section,
        match,
        groups,
        displayMode,
        gridLocalization,
        isChoosenMatch,
        gridSelection: props.gridSelection,
        selectionToggleMatchAction: props.selectionToggleMatchAction
    };
}

function buildGroups(groups) {
    let rootGroups = groups.filter(group => group.get('parentId') == null);
    groups = cleanGroups(groups, rootGroups);

    rootGroups.forEach((rootGroup, index) => {
        let newRootGroup = appendChildGroups(rootGroup);
        rootGroups = rootGroups.set(index, newRootGroup)
    });

    function appendChildGroups(rootGroup) {
        let childGroups = groups.filter((group) => group.get('parentId') === rootGroup.get('type'));
        groups = cleanGroups(groups, childGroups);

        childGroups.forEach((childGroup, index) => {
            let newLevelChildGroups = groups.filter((group) => group.get('parentId') === childGroup.get('type'));
            const hasNewLevelChildGroups = newLevelChildGroups.size > 0;

            if (hasNewLevelChildGroups) {
                let newChildGroup = appendChildGroups(childGroup, childGroups);
                childGroups = childGroups.set(index, newChildGroup);
            }

            groups = cleanGroups(groups, newLevelChildGroups);
        });

        return rootGroup.set('childGroups', childGroups);

    }

    const hasNotAppendedGroups = groups.size > 0;

    if (hasNotAppendedGroups) {
        rootGroups = rootGroups.concat(groups);
    }
    return rootGroups;
}

function buildCustomNestingGroups(sportId, groups) {
    if (groups.size === 0) {
        return groups.toArray();
    }
    const nestingConfig = groupNesting[sportId];

    if (!nestingConfig) {
        return groups.toArray();
    }

    const groupKeys = Object.keys(nestingConfig);
    if (groupKeys.length === 0) {
        return groups.toArray();
    }

    let customNestingGroups = [];
    let foundNestedGroupTypes = [];
    let foundParent = false;

    groups.forEach((group) => {
        const groupType = group.get('type');
        const nestedGroupTypes = nestingConfig[groupType];
        if (!foundParent && containsValue(groupKeys, groupType) && nestedGroupTypes) {
            foundParent = true;
            foundNestedGroupTypes = nestedGroupTypes;

            const nestedGroups = groups.filter(g => nestedGroupTypes.indexOf(g.get('type')) !== -1);
            group = group.set('childGroups', nestedGroups);

            customNestingGroups.push(group);
        } else {
            if (!containsValue(foundNestedGroupTypes, groupType)) {
                customNestingGroups.push(group);
            }
        }
    });

    return customNestingGroups;
}

function containsValue(arr, val) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
            return true;
        }
    }

    return false;
}

function cleanGroups(groups, groupsToRemove) {
    return groups.filterNot((group) => groupsToRemove.includes(group));
}

export default connect(select)(RegularMatch);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/RegularMatch.jsx